module.exports = __webpack_public_path__ + "static/media/SFUIDisplay-Bold.8757032d.ttf";